import ErrorResults from "./error-results";

export default ErrorResults;
